// extracted by mini-css-extract-plugin
export default {"iconSVG":"Icons__iconSVG___hnI9m"};